import React from 'react';
import { useStudioTypeSize } from '../StudioTypeScale';
import type { StudioPageContent } from '../../../constants';
import LayoutFrame, { type LayoutContentProps } from './LayoutFrame';

interface QuoteContentProps extends Partial<LayoutContentProps> {
  content: StudioPageContent;
  format: string;
}

const QuoteContent: React.FC<QuoteContentProps> = ({ content, format, tokens }) => {
  const isStory = format === 'story';
  const t = tokens!;
  const typeSize = useStudioTypeSize();

  return (
    <div style={{ position: 'relative' }}>
      <div
        style={{
          color: t.accent,
          opacity: t.mode === 'vibrant' ? 0.32 : 0.22,
          fontFamily: 'Georgia, serif',
          fontSize: typeSize(isStory ? 106 : 84),
          fontWeight: 700,
          lineHeight: 0.5,
          height: isStory ? 60 : 46,
          marginLeft: -6
        }}
      >
        “
      </div>
      <div
        style={{
          position: 'relative',
          maxWidth: 306,
          color: t.ink,
          fontSize: typeSize(isStory ? 24.5 : 20),
          fontWeight: 700,
          letterSpacing: '-0.4px',
          lineHeight: 1.38
        }}
      >
        {content.quote}
      </div>
      {content.author && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 11,
            marginTop: isStory ? 26 : 19,
            color: t.muted,
            fontSize: typeSize(isStory ? 12.5 : 11),
            fontWeight: 600,
            letterSpacing: 0.3,
            textTransform: 'uppercase'
          }}
        >
          <span
            style={{
              display: 'block',
              width: 26,
              height: 3,
              flexShrink: 0,
              borderRadius: 2,
              background: t.accent
            }}
          />
          <span>{content.author}</span>
        </div>
      )}
    </div>
  );
};

interface QuoteLayoutProps {
  width: number;
  height: number;
  format: string;
  content?: StudioPageContent;
  themeColor?: string;
  profileName?: string;
}

const QuoteLayout: React.FC<QuoteLayoutProps> = props => (
  <LayoutFrame {...props}>
    <QuoteContent content={props.content || {}} format={props.format} />
  </LayoutFrame>
);

export default QuoteLayout;
